import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleLeft } from '../../Actions/AllAction';

import { setToken, logOutApp, setUserCredentials, setUserEntryType, setTabGridLabel } from '../../GlobalModules/Login/Actions/LoginAction';


import { Tooltip as ReactTooltip } from 'react-tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import CustomInput from '../Components/CustomInput';
import Config from '../Config'
import * as UtilityController from '../Controller/UtilityController';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { withRouter } from 'react-router';

import * as LoginController from '../../GlobalModules/Login/Controller/LoginController';

import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';

import ModalGlobal from './ModalGlobal';
import ConfirmationAlert from './ConfirmationAlert';
import ChangePasswordContent from './ChangePasswordContent';
import AutosuggestComponent from '../Components/AutosuggestComponent';
import AlertNotification from '../Components/AlertNotification';
import UserProfileContent from './UserProfileContent';
import ChatHistoryModal from './ChatHistoryModal';
import { getCurrentUser } from '../../GlobalModules/Login/Controller/LoginController';
import UserProfile from '../../GlobalModules/UserProfile/Pages/UserProfile';
import AutosuggestComponentSwitchBusiness from '../../GlobalModules/Utility/Components/AutosuggestComponent';
const channel = new BroadcastChannel('foobar');
import { EventEmitter } from '../../Utility/EventEmitter';

class Header extends Component {
    constructor(props) {
        super(props)
        this.handleBar = this.handleBar.bind(this);
        this.state = {
            subheaderShow: true,
            windowWidth: window.innerWidth,
            changePasswordModalOpen: false,
            formData: {
                userEmail: "",
                password: "",
                newPassword: "",
                confirmPassword: ""
            },
            errorData: {
                userEmailError: "",
                passwordError: "",
                newPasswordError: "",
                confirmPasswordError: ""
            },

            limit: 5,
            offset: 0,
            notificationsData: [],
            showLoadmore: false,
            showPopup: false,
            notificationVisible: false,
            langaugeConfirmModal: false,
            selectedLangauge: '',
            changePasswordFlag: false,
            unreadNotificationCount: 0,
            versionOption: [],
            selectedVersionValue: [],

            //alert notification
            show: true,
            notificationData: [],
            zoominzoomoutflag: "",
            chatHistoryFlag: false,
            myProfileModalFlag: false,
            isLogout: false,
        }
        this.codeOutsideClickRef = React.createRef();
    }
    logout = () => {
        const { logOutApp, history, setToken, setUserCredentials, loaderStateTrue, loaderStateFalse } = this.props;

        loaderStateTrue()
        logOutApp(this.props.accessToken, this.props.token).then((logoutResponce) => {
            setTimeout(() => {
                this.setState({
                    isLogout: true
                }, () => {
                    if (logoutResponce.success) {
                        localStorage.setItem("selectedTabName", "")
                        setToken("", "", "", "", [], [], '').then((res) => {
                            setUserCredentials({});
                            // Redirect to login page after successful logout
                            const currentLang = localStorage.getItem('i18nextLng') || 'en';
                            history.push(`/${currentLang}/login`);
                        })
                    } else {
                        localStorage.setItem("selectedTabName", "")
                        setToken("", "", "", "", [], [], '').then(() => {
                            setUserCredentials({});
                            // Redirect to login page even if logout API fails
                            const currentLang = localStorage.getItem('i18nextLng') || 'en';
                            history.push(`/${currentLang}/login`);
                        })
                    }

                    let obj = {
                        isLogout: this.state.isLogout,
                        allTabAction: "logoutAllTab"
                    }
                    channel.postMessage(obj);
                })
            }, 1000)
            loaderStateFalse()
        }).catch((error) => {
            // Handle logout API error and still redirect to login
            console.error('Logout error:', error);
            localStorage.setItem("selectedTabName", "")
            setToken("", "", "", "", [], [], '').then(() => {
                setUserCredentials({});
                const currentLang = localStorage.getItem('i18nextLng') || 'en';
                history.push(`/${currentLang}/login`);
            })
            loaderStateFalse()
        })
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    };


    componentDidMount = () => {
        document.body.addEventListener('mousedown', this.handleClickOutside.bind(this));
        if (this.state.show) {
            this.showNotificationGetApiCall()
        }
        //this.setVersionData();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
        if (document.body) {
            document.body.removeEventListener('mousedown', this.handleClickOutside.bind(this));
        }
    }

    async handleClickOutside(event) {
        const concernedElement = document.querySelector(".popover_notificationParrent");
        if (concernedElement && concernedElement.contains(event.target)) {
            //console.log("click inside");
        } else {
            this.setState({
                showPopup: false,
                notificationsData: [],
                offset: 0,
                limit: 5
            })
        }
    }

    notificationsUi = () => {
        const { notificationsData } = this.state;
        //console.log("notificationsData ++++++", notificationsData)
        let notiArry = []
        if (notificationsData.length > 0) {
            notificationsData.map((value, idx) => {
                let profileImage = value.profile_img_temp;

                if (value.is_read) {
                    notiArry.push(
                        <div className="popover_notification_row notidivider isread" key={idx} >
                            <div className="noti_icon_box">
                                <img className="noti_icon" src={profileImage} />
                            </div>
                            <div className="noti_user_box"><span>{value.job_info.name}<em>{value.job_info.subject}</em></span></div>
                        </div>
                    )
                } else {
                    notiArry.push(
                        <div className="popover_notification_row notidivider notisread" key={idx} onClick={() => this.notificationsRead(value.id)}>
                            <div className="noti_icon_box">
                                <img className="noti_icon" src={profileImage} />
                            </div>
                            <div className="noti_user_box"><span>{value.job_info.name}<em>{value.job_info.subject}</em></span></div>
                        </div>
                    )
                }
            })
        }

        return notiArry;
    }

    loadMore = () => {
        const { limit, offset } = this.state;
        this.setState({
            offset: offset + limit
        }, () => {
            this.userNotifications().then((res) => {
                if (res.length > 0) {
                    this.setState({
                        notificationsData: [...this.state.notificationsData, ...res],
                        //showLoadmore: res.total > 5 ? true : false
                    }, () => {
                        //console.log("notificationsData===concat", this.state.notificationsData)
                        this.notificationsUi();
                    })
                } else {
                    this.setState({
                        showLoadmore: false
                    })
                }
            })
        })

    }

    userNotifications = () => {
        let promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse, userCredentials } = this.props;
            const { limit, offset } = this.state;
            //console.log("userCredentials==>>", userCredentials)
            let param = {}
            if (userCredentials.id == 1) {
                param = {
                    "limit": limit,
                    "offset": offset,
                    "type": "notification",
                    "user_id": userCredentials.id
                };
            } else {
                param = {
                    "limit": limit,
                    "offset": offset,
                    "type": "notification",
                    "user_id": userCredentials.id
                };
            }

            let filters = {};
            filters['filters'] = JSON.stringify(param);

            loaderStateTrue()
            UtilityController.notifications(filters).then((res) => {
                //console.log("res=======11111111", res)
                if (res.success) {
                    this.setState({
                        unreadNotificationCount: res.unread_notification,
                        showLoadmore: res.total > 5 ? true : false,
                        showPopup: true
                    })

                    let promiseArr = []
                    res.data.map((item, index) => {
                        let userId = item.job_info.user_id;
                        //console.log("userId", userId)
                        let promise = new Promise((resolve, reject) => {
                            this.profileImageUi(userId).then((data) => {
                                // tempUserProfileDetailsHash[item.id.toString()] = data
                                item["profile_img_temp"] = data
                                resolve(item)
                            })

                        })
                        promiseArr.push(promise)
                    })

                    //console.log("promiseArr", promiseArr)

                    Promise.all(promiseArr).then((values) => {
                        //console.log("values==========>", values)
                        resolve(values)
                    });

                }

                loaderStateFalse()
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }

                if (error.message == "Network Error") {

                }
                loaderStateFalse()
            });
        })
        return promise

    }

    profileImageUi = (id) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse, userProfileId } = this.props;
            loaderStateTrue();
            let data = {};
            data["filters"] = JSON.stringify(Config.thumbnailSize)
            UtilityController.user_Details(id, data).then((response) => {
                if (response.success) {
                    //console.log("response.data[0]========", response.data[0])
                    if (response.data.length > 0) {
                        let responseUserDetails = response.data[0].profile_img
                        if (responseUserDetails && Object.keys(responseUserDetails).length > 0) {
                            resolve(responseUserDetails.file_obj)
                        } else {
                            resolve(require('../Public/images/usericon.png'))
                        }
                    } else {
                        resolve(require('../Public/images/usericon.png'))
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                    /*Utility.toastNotifications("Please login", "Error", "error");
                    this.props.logOutApp().then(
                        () => this.props.history.push("/")
                    );*/
                }
            });
        })
        return promise;
        /*promise.then((img) => {
            console.log("img===========>",img)
            return <div className="gridusericon"><img src={img} /></div>
        })*/

    }

    notificationsRead = (id) => {

        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let ids = {

            "ids": [id]

        };
        UtilityController.notificationsUserId(ids, "patch").then((response) => {
            //console.log()
            if (response[0].success) {
                //this.userNotifications()
                //this.leaveSyncronization()
                //this.resetDataGrid();
                //this.closeLeaveRequestModal();
                //this.clearData()
                this.showPopup()
                //Utility.toastNotifications(response.message, "Success", "success");
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
                //Utility.toastNotifications(error.message, "Error", "error");
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
                // Utility.toastNotifications("Please login", "Error", "error");
                // this.props.logOutApp().then(
                //     () => this.props.history.push("/")
                // );
            }
        });



    }

    handleOutsideClickMenuleft(e) {


        if (e.target.offsetParent) {
            if (e.target.localName != "aside") {
                if (e.target.className != "nav-link") {
                    this.props.handleLeft(false);
                }
            }
        } else {

            if (e.target.parentNode.className != "nav-link") {
                //console.log("header=========",3);
                if (e.target.parentNode.className.animVal != "float-right") {
                    //console.log("header=========",4);				
                    //this.props.handleLeft(false);
                }
            }
            if (e.target.className.animVal == "fa-bars-menu") {
                //console.log("header=========",5);
                this.props.handleLeft(false);
            }
            if (e.target.parentNode.className.animVal == "fa-bars-menu") {
                //console.log("header=========",6);
                this.props.handleLeft(false);
            }
        }

    }
    handleBar = () => {
        this.props.handleLeft(!this.props.leftbar)
    }

    lanOnSelect = (lng) => {
        this.setState({
            langaugeConfirmModal: true,
            selectedLangauge: lng,

        })
    }


    confirmLangaugeChange = () => {

        const { selectedLangauge } = this.state;
        this.props.i18n.changeLanguage(selectedLangauge);
        let splitUrl = this.props.match.url.split('/');
        this.props.history.push(`/${selectedLangauge}/${splitUrl[2]}`);
        window.location.reload();
        this.setState({
            langaugeConfirmModal: false
        })

    }

    cancelLangaugeChange = () => {
        this.setState({
            langaugeConfirmModal: false,
        })
    }

    popover = () => (
        <Popover className="popover_notification">
            <Popover.Content>

                <div className="popover_notification_row">
                    <h3 className="notititle">{this.props.t('notifications')}</h3>
                </div>

                <div>
                    {this.notificationsUi()}
                    {this.state.showLoadmore ?
                        <div onClick={this.loadMore}>{this.props.t('loadMore')}</div>
                        : null}
                </div>


            </Popover.Content>
        </Popover>
    );

    showPopup = () => {
        this.userNotifications().then((res) => {
            //console.log("res==========", res)
            this.setState({
                notificationsData: res,
            }, () => {
                this.notificationsUi();
            })
        })
    }


    changePassword = () => {
        this.setState({
            changePasswordFlag: true
        })
    }

    closeChangePassword = () => {
        this.setState({
            changePasswordFlag: false,
            zoominzoomoutflag: ""
        })
    }


    handleVersionChange = (event) => {
        let copyObject = Object.assign({}, this.props.userCredentials);
        copyObject["user_details"]["version"] = event.label.toLowerCase();
        copyObject["user_details"]["version_id"] = event.value;
        this.props.setUserCredentials(copyObject);
    }


    //alert notification
    handleCrossButtonClick = (id) => {
        this.setState((prevState) => ({
            notificationData: prevState.notificationData.filter((error) => error.id !== id)
        }));
    };

    showNotificationGetApiCall = () => {
        let filters = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["status"] = true;
        filters['filters'] = JSON.stringify(globalQueryParamshash);
        this.props.loaderStateTrue();
        UtilityController.showNotification(filters).then((response) => {
            // console.log("response--------------->", response)
            if (response.success) {
                if (response.data != null && response.data.length > 0) {
                    let responseDataTempArray = [];
                    let responseDataTempObj = {};
                    response.data.map((e, index) => {
                        responseDataTempObj = {};
                        responseDataTempObj["message"] = e.message;
                        responseDataTempObj["id"] = index;
                        responseDataTempArray.push(responseDataTempObj)
                    })
                    this.setState({
                        notificationData: responseDataTempArray
                    })

                } else {
                    this.setState({
                        notificationData: []
                    })
                }

            } else {
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            this.props.loaderStateFalse();
        }).catch((error) => {
            //console.log('----------error-------', error);
            this.props.loaderStateFalse();
        });
    }

    zoominFunction = () => {
        //console.log("-----zoom in ------------")
        let zoominzoomoutflag = "zoominzoomoutclass"
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag
        })
    }
    zoomoutFunction = () => {
        //console.log("-----zoom out ------------")
        let zoominzoomoutflag = ""
        this.setState({
            zoominzoomoutflag: zoominzoomoutflag
        })
    }


    openChatListComponent = () => {
        //open the chat list component
        this.setState({ chatHistoryFlag: true })
    }
    closechatHistoryFlag = () => {
        //open the chat list component
        this.setState({ chatHistoryFlag: false })
    }

    //current user data get
    getCurrentUserData = () => {
        const { setUserCredentials } = this.props;
        this.redirectToDashboardTab();
        getCurrentUser().then((response) => {
            if (response.success) {
                setUserCredentials(response.data);
                this.props.history.push('/');
            }
        }).catch((error) => {
            console.error("************error*************", error)
            loaderStateFalse();
        });
    }

    loadTabAndGridLabel = () => {
        loaderStateTrue();
        LoginController.getAllTabGridLable().then((response) => {
            // console.log("response===========", response)
            if (response.success) {
                const parseResponseData = response.data.map(item => {
                    return {
                        ...item,
                        setting_data: JSON.parse(item.setting_data)
                    };
                });
                this.props.setTabGridLabel(parseResponseData)
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    }

    redirectToDashboardTab = () => {
        localStorage.setItem("selectedTabName", 'dashboardTab')
    }

    //profile modal open
    myProfileFN = () => {
        this.setState({
            myProfileModalFlag: true
        })
    }

    //close my profile modal
    closemyProfileModal = () => {
        let zoominzoomoutflag = ""
        this.setState({
            myProfileModalFlag: false,
            zoominzoomoutflag: zoominzoomoutflag
        })
    }

    detectChangesIndividualTab = (value = false) => {
        this.setState({
            tabchangeParent: value
        })

    }

    render() {
        const { userCredentials } = this.props;
        const { subheaderShow, windowWidth, changePasswordModalOpen, formData, errorData } = this.state;
        /*let profileImageLink = require('../Public/images/no_found.png');
        if (userCredentials.hasOwnProperty("custom:testjson") && userCredentials.hasOwnProperty("picture") && userCredentials["picture"] != 'null') {
            userName = JSON.parse(userCredentials["custom:testjson"]).userName
            profileImageLink = JSON.parse(userCredentials["picture"])[0].link
        }*/
        // console.log('userCredentials.user_details+++++++????????//-------------------->', userCredentials)
        // console.log('userCredentials.user_details.profile_img_url.file_obj-------------------->', userCredentials.user_details.profile_img_url.file_obj)

        let user_email = "";
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.user_email != "") {
            user_email = userCredentials.user_details.user_email
        }

        if (user_email == "" && userCredentials && userCredentials.user_details && userCredentials.user_details.contact_number != "") {
            user_email = userCredentials.user_details.contact_number
        }

        let user_profile_image = "";
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('profile_img_url') && userCredentials.user_details.profile_img_url && JSON.parse(userCredentials.user_details.profile_img_url).hasOwnProperty('img_url') && JSON.parse(userCredentials.user_details.profile_img_url).img_url) {
            user_profile_image = JSON.parse(userCredentials.user_details.profile_img_url).img_url
        }
        let user_first_name = userCredentials && userCredentials.user_details && userCredentials.user_details.first_name
        let user_last_name = userCredentials && userCredentials.user_details && userCredentials.user_details.last_name

        let roleName = this.props.userCredentials?.user_details?.user_type

        let selectedVersion = { "value": this.props.userCredentials?.user_details?.version_id, "label": this.props.userCredentials?.user_details?.version.charAt(0).toUpperCase() + this.props.userCredentials?.user_details?.version.slice(1) };

        let userType = {
            label: `${this.props.userEntryType && this.props.userEntryType?.org_name.length > 0 ? `${this.props.userEntryType?.org_name}` : ''}`,
            value: this.props.userEntryType?.id,
            tooltipShow: `${this.props.userEntryType && this.props.userEntryType?.org_name}`.length > 12 ? true : false
        };
        let userId = this.props.userCredentials?.id
        var rowData = {
            "user_type": roleName
        }
        //console.log("roleName========", roleName)
        // console.log('version-------------ccccccccccc-->', this.props.version)
        return (
            <div className="header-top-inner">
                <header className={roleName != "app_admin" && this.state.notificationData.length > 0 ? "header_main header_main_index" : "header_main"} >
                    {/* this.state.notificationData.length */}
                    {/*<div className={this.props.leftbar ? "brand-w-button header_left left_border_open" : "brand-w-button header_left left_border_close"}>
						<svg width="15" height="15" viewBox="0 0 14 14" fill="none" onClick={this.handleBar} style={{ cursor: 'pointer' }}>
							<path d="M0.5 3.125H13.5C13.75 3.125 14 2.90625 14 2.625V1.375C14 1.125 13.75 0.875 13.5 0.875H0.5C0.21875 0.875 0 1.125 0 1.375V2.625C0 2.90625 0.21875 3.125 0.5 3.125ZM0.5 8.125H13.5C13.75 8.125 14 7.90625 14 7.625V6.375C14 6.125 13.75 5.875 13.5 5.875H0.5C0.21875 5.875 0 6.125 0 6.375V7.625C0 7.90625 0.21875 8.125 0.5 8.125ZM0.5 13.125H13.5C13.75 13.125 14 12.9062 14 12.625V11.375C14 11.125 13.75 10.875 13.5 10.875H0.5C0.21875 10.875 0 11.125 0 11.375V12.625C0 12.9062 0.21875 13.125 0.5 13.125Z" fill="white" fillOpacity="0.54" />
						</svg>
					</div>*/}
                    {roleName != "app_admin" ?
                        <div className='alert_box_inner_con'>
                            <AlertNotification
                                show={this.state.show}
                                notificationData={this.state.notificationData}
                                handleCrossButtonClick={this.handleCrossButtonClick}
                            /></div> : null}

                    <div className="header_right user_icon_innner" >
                        {this.props.hasOwnProperty("userGroup") && this.props.userGroup && this.props.userGroup.length > 1 ?
                            <div className='switchOrganizationBoxInner'>
                                <div className="switchOrganizationBoxContainer">
                                    <label>View Account</label>
                                    <div className="dropdownBoxContainer versiondropBox dropdownCustomizeContainer">
                                        <AutosuggestComponentSwitchBusiness
                                            handleOnChange={(e) => {
                                                this.props.setUserEntryType(e);// User entry type
                                                setTimeout(() => {
                                                    this.getCurrentUserData();
                                                    this.loadTabAndGridLabel();
                                                }, 100);
                                            }}
                                            options={this.props.userGroup ? this.props.userGroup.map((role, idx) => ({
                                                ...role,
                                                label: `${this.props.userGroup?.[idx].org_name}`,
                                                value: this.props.userGroup?.[idx].id,
                                                tooltipShow: `${this.props.userGroup?.[idx].org_name}`.length > 12 ? true : false
                                            })) : []}
                                            selectedValue={userType}
                                            name=''
                                            isMulti={false}
                                            placeholder="Choose business type..."
                                            isDisabled={false}
                                            closeButton={false}
                                            menuHeader="Choose business type"
                                            isSearchable={true}
                                            classNamePrefix="common-dropdown-box"
                                        />
                                    </div>
                                </div>
                            </div>
                            : null}

                        {(this.props.userCredentials?.user_details?.user_type != "app_admin" && ["v3.0.1", "v4", "v5", "v6"].includes(this.props.userCredentials?.user_details?.version) && this.props.userCredentials?.user_details.hasOwnProperty('subscription_ended') && this.props.userCredentials?.user_details.subscription_ended != null && this.props.userCredentials?.user_details.subscription_ended == false) ?
                            <button className="quick_message_btn" onClick={() => this.openChatListComponent()}>
                                New Message
                            </button> : null}
                        {/* {(this.props.userCredentials?.user_details?.user_type != "app_admin" && ["v3.0.1", "v4", "v5", "v6"].includes(this.props.userCredentials?.user_details?.version) && this.props.userCredentials?.user_details.hasOwnProperty('subscription_ended') && this.props.userCredentials?.user_details.subscription_ended != null && this.props.userCredentials?.user_details.subscription_ended == true) ?
                            <p style={{ fontSize: '12px', width: '100%', color: 'red', fontWeight: 599}}>
                                You do not have any active plans. Please reach out to Waliner team.
                            </p> : null} */}

                        <ul className="nav_ul">
                            {/*<li style={{ color: '#fff', paddingTop: 1 }}>{userName}</li>*/}
                            {/*<OverlayTrigger
								rootClose={true}
								trigger="click"
								placement="bottom"
								overlay={
									<Popover className="popover_action_inner">
										<Popover.Content>
											<div className="popover_action_row">
												<button className="popover_action_btn" onClick={this.changePassword}>Change Password</button>
											</div>
										</Popover.Content>
									</Popover>
								}
							>
							<li><i className="fa fa-cog" aria-hidden="true"></i></li>
							</OverlayTrigger>*/}
                            <li style={{ display: 'none' }}>
                                <div className="srchBox">
                                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                    <CustomInput
                                        parentClassName="comment_input_field"
                                        name="srchBox"
                                        type="text"
                                        placeholder={this.props.t('searchworker')}
                                    //onChange={this.handleSearchBar}
                                    />
                                </div>
                            </li>

                            {/* <OverlayTrigger
								rootClose={true}
								trigger="click"
								placement="bottom"
								show={this.state.showPopup}
								overlay={
									<Popover className="popover_notification">
										<Popover.Content>

											<div className="popover_notification_row">
												<h3 className="notititle">{this.props.t('notifications')}</h3>
											</div>

											<div className="popover_notificationParrent" ref={this.codeOutsideClickRef}>
												<div className='notificationsUiBox'>{this.notificationsUi()}</div>
												{this.state.showLoadmore ?
													<div onClick={this.loadMore} className="savebtn">{this.props.t('loadMore')}</div>
													: null}
											</div>


										</Popover.Content>
									</Popover>
								}

							>

								<li className="notificationbar" onClick={this.showPopup}><i className="fa fa-bell" aria-hidden="true"></i>{this.state.unreadNotificationCount > 0 ? <sup></sup> : null}</li>

							</OverlayTrigger> */}
                            {roleName == "app_admin" ?
                                <li style={{ display: 'none' }}>
                                    <div className="dropdownbox versiondrop">
                                        <AutosuggestComponent
                                            handleOnChange={(e) => { this.handleVersionChange(e) }}
                                            options={this.props.version}
                                            selectedValue={selectedVersion}
                                            name=''
                                            isMulti={false}
                                            placeholder="Choose version"
                                            isDisabled={false}
                                            //isClearable={true}
                                            closeButton={true}
                                            menuHeader="Choose version"
                                            isSearchable={true}
                                        />
                                    </div>
                                </li> : null}


                            {/* {user_profile_image != "" ?
                                <li><img className="user_icon" src={user_profile_image} /></li>
                                :
                                <li><div className="header_user_name" data-tip={`${user_first_name} ${user_last_name}`}>{user_first_name && user_first_name.charAt(0)}{user_last_name && user_last_name.charAt(0)}</div>
                                    <ReactTooltip place="bottom" />
                                </li>
                            } */}
                            {/* <button onClick={() => this.openChatListComponent()}>Quick Message</button> */}
                            <UserProfileContent
                                userProfileImage={user_profile_image}
                                userDetails={userCredentials.user_details}
                                userFirstName={user_first_name}
                                userLastName={user_last_name}
                            />
                            <OverlayTrigger
                                rootClose={true}
                                trigger="click"
                                placement="bottom"
                                overlay={
                                    <Popover className="popover_action_inner">
                                        <Popover.Content>
                                            <div className="popover_action_row">
                                                <button className="mailtext" onClick={this.myProfileFN}>{this.props.t('My Profile')}</button>
                                                {/* <button className="mailtext">{user_email}</button> */}
                                                <button className="changePasswordtext" onClick={this.changePassword}>{this.props.t('ChangePasswordButton')}</button>
                                                <button className="logouttext" onClick={this.logout}>{this.props.t('logoff')}</button>
                                            </div>
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <li className="logoutbox"><i className="fa fa-sort-desc" aria-hidden="true"></i></li>
                            </OverlayTrigger>
                            {/* <li className="langdropdown">

								<Dropdown onSelect={this.lanOnSelect.bind(this)}>
									<Dropdown.Toggle variant="success" id="dropdown-basic" >
										{localStorage.getItem('i18nextLng').toUpperCase()}
									</Dropdown.Toggle>

									<Dropdown.Menu>
										<Dropdown.Item eventKey="en">EN</Dropdown.Item>
										<Dropdown.Item eventKey="fr">FR</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>

							</li> */}

                        </ul>
                        {(this.props.userCredentials?.user_details?.user_type != "app_admin" && ["v3.0.1", "v4", "v5", "v6"].includes(this.props.userCredentials?.user_details?.version) && this.props.userCredentials?.user_details.hasOwnProperty('subscription_ended') && this.props.userCredentials?.user_details.subscription_ended != null && this.props.userCredentials?.user_details.subscription_ended == true) ?
                            <p style={{ fontSize: '10px', width: '100%', color: 'red', fontWeight: 599, margin: 0, lineHeight: '8px', background: '#fff', position: 'relative', zIndex: 11111 }}>
                                You do not have any active plans. Please reach out to Waliner team.
                            </p> : null}
                    </div>
                    <ModalGlobal
                        show={this.state.langaugeConfirmModal}
                        onHide={this.cancelLangaugeChange}
                        className="modalcustomize confirmationalertmodal"
                        bodyClassName="cancelConfirmationbody"
                        headerclassName="close_btn_icon"
                        title={this.props.t('languagechange')}
                        footer={false}
                        body={
                            <ConfirmationAlert
                                BodyFirstContent={this.props.t('areYouSureYouWantToReload')}
                                confirmationButtonContent={this.props.t('confirm')}
                                deleteConfirmButton={this.confirmLangaugeChange}
                                cancelButtonContent={this.props.t('cancel')}
                                deleteCancleButton={this.cancelLangaugeChange}
                            />
                        }
                    />

                    <ModalGlobal
                        show={this.state.changePasswordFlag}
                        onHide={this.closeChangePassword}
                        className={`${this.state.zoominzoomoutflag + ' ' + "modalcustomize changePasswordModal"}`}
                        bodyClassName="cancelConfirmationbody"
                        headerclassName="close_btn_icon"
                        title={this.props.t('ChangePasswordButton')}
                        footer={false}
                        closeButton={true}
                        zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                        zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                        zoomin={this.zoominFunction}
                        zoomout={this.zoomoutFunction}
                        body={
                            <ChangePasswordContent
                                closeChangePassword={this.closeChangePassword}
                            />
                        }
                    />

                    <ModalGlobal
                        show={this.state.chatHistoryFlag}
                        onHide={this.closechatHistoryFlag}
                        className={`${this.state.zoominzoomoutflag + ' ' + "modalcustomize changePasswordModal chatModal chatHistoryModalDialog chatHistoryModalCommon"}`}
                        bodyClassName="cancelConfirmationbody"
                        headerclassName="close_btn_icon"
                        //title={this.props.t('ChangePasswordButton')}
                        footer={false}
                        closeButton={true}
                        zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                        zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                        zoomin={this.zoominFunction}
                        zoomout={this.zoomoutFunction}
                        body={
                            <ChatHistoryModal
                                globalChat={true}
                            />
                        }
                    />
                    <ModalGlobal
                        show={this.state.myProfileModalFlag}
                        onHide={this.closemyProfileModal}
                        className={`${this.state.zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension myProfileModalDialog"}`}
                        bodyClassName="profileDetailsModalbody"
                        headerclassName="close_btn_icon"
                        saveButtonLabel="Submit"
                        saveButtonClassName="btn btn-primary savebtn modBtnSave"
                        title={this.props.t('My Profile')}
                        footer={false}
                        closeButton={true}
                        zoominButton={this.state.zoominzoomoutflag != "" ? false : true}
                        zoomoutButton={this.state.zoominzoomoutflag != "" ? true : false}
                        zoomin={this.zoominFunction}
                        zoomout={this.zoomoutFunction}
                        cancelButtonClassName="modBtnSave cancelbtn"
                        footerClassName="text-center topspaceUserProfile"
                        body={

                            <UserProfile
                                profilecontentdispaly="profilecontentdispaly"
                                userProfileId={userId}
                                detectChangesIndividualTab={this.detectChangesIndividualTab}
                                selectedRowsData={rowData}
                                profileView={true}
                            />
                        }
                    />
                </header >
            </div>
        )
    }
}

const mapStateToProps = (globalState) => {
    //console.log("globalState.LoginReducer.version------------->", globalState.LoginReducer.userCredentials)
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        accessToken: globalState.LoginReducer.accessToken,
        token: globalState.LoginReducer.token,
        leftbar: globalState.mainReducerData.leftbar,
        version: globalState.LoginReducer.version,
        userGroup: globalState?.LoginReducer?.userGroup,
        userEntryType: globalState.LoginReducer?.userEntryType,
    };
}
export default withRouter(connect(mapStateToProps, { handleLeft, loaderStateTrue, loaderStateFalse, setToken, setUserEntryType, setUserCredentials, logOutApp, setTabGridLabel })(withTranslation()(Header)));